export default {
  computed: {
    completedSections() {
      const completedId = this.
        $store.
        getters['categoryStatuses/completedStatus'].
        id;
      const completedStates = this.categoryStates.filter( s => s.categoryStatusId == completedId );
      const completedSectionIds = completedStates.map( s => s.categoryId );
      const sections = this.sections.filter( s => completedSectionIds.includes(s.id) );
      return sections.sort( (a, b) => a.order - b.order );
    },
    inProgressSections() {
      const inProgressId = this.
        $store.
        getters['categoryStatuses/inProgressStatus'].
        id;
      const inProgressSectionStates = this.categoryStates.filter( s => s.categoryStatusId == inProgressId );
      const inProgressSectionIds = inProgressSectionStates.map( s => s.categoryId );
      return this.sections.filter( s => inProgressSectionIds.includes(s.id) );
    },
    simId() {
      return this.$route?.params['simId'];
    },
    timeRemaining() {
      if( this.currentCategoryState ){
        const milliseconds = this.currentSection.timeInMinutes * 60 * 1000;
        return Math.max(milliseconds - (Date.now() - this.currentCategoryState.mobileCreatedAt), 0);
      }
    },
    category() {
      const categories = this.$store.getters['categories/all'];
      const category = categories.find( c => c.id == this.simId);
      return category;
    },
    categoryStates() {
      const allStates = this.$store.getters['categoryStates/categoryStates'];
      const states = this.sections.map( s => allStates[s.id] ).filter( i => i );
      return states;
    },
    currentCategoryState() {
      const inProgressId = this.
        $store.
        getters['categoryStatuses/inProgressStatus'].
        id;
      const inProgressSectionStates = this.categoryStates.filter( s => s.categoryStatusId == inProgressId );
      if( inProgressSectionStates.length > 1 ) {
        // ruh ro
        console.log('More than one in progress section');
        return;
      }
      if( inProgressSectionStates.length == 1 ) {
        return inProgressSectionStates[0];
      } else {
        // look for the last completed section
        const completedStates = this.
          categoryStates.
          filter( s => s.categoryStatusName == 'completed' ).
          sort( (a, b) => a.updatedAt > b.updatedAt );
        if( completedStates.length > 0) {
        }
      }
    },
    flashcardStates() {
      // TODO:
      //   This is currently just finding the states to the flashcards that happen to be in sections
      //     Some of these flashcards could be in different categories as well
      //     this needs to also check the category / flashcardid combination as well
      const allIds = this.sectionFlashcardIds;
      const states = this.$store.getters['flashcardStates/flashcardStateList'];
      const filteredStates = states.filter( s => allIds.includes(s.flashcardId) );
      return filteredStates;
    },
    sections() {
      let categories = this.$store.getters['categories/all'];
      const childrenIds = this.category.children;
      let childrenCategories = categories.filter( c => childrenIds.includes(c.id) );
      childrenCategories = childrenCategories.sort( (a, b) => a.order - b.order );
      console.log(childrenCategories);
      return childrenCategories;
    },
    simConfig() {
      const configs = this.$store.getters['simulationConfigs/all'];
      const categoryId = this.category?.id;
      return configs.find( c => c.categoryId == categoryId);
    },
    sectionFlashcardIds() {
      return this.sections.flatMap( section => {
        const sectionFlashcards = this.sectionFlashcards(section);
        const ids = sectionFlashcards.map( f => f.id );
        return ids;
      });
    },
    nextSection() {
      let length = this.completedSections.length;
      if( this.inProgressSections.length == 1 ) {
        length++;
      }
      return this.sections[length];
    },
    currentSection() {
      const currentSectionId = this.currentCategoryState?.categoryId;
      return this.sections.find(s => s.id == currentSectionId);
    },
  },
  methods: {
    /* BEGIN WUX SIMULATION */
    sectionFlashcardStates(section) {
      if( !section ) { return []; }
      const sectionId = section.id;
      const flashcardIds = this.sectionFlashcards(section).map( f => f.id );
      let flashcardStates = this.flashcardStates.filter( f => f.categoryId == sectionId );
      flashcardStates = flashcardStates.filter( f => flashcardIds.includes(f.flashcardId) );
      return flashcardStates;
    },
    async startSection(section) {
      /*
        To start a section
          - check that the user can start this section
            - may not have any other in progress sections
            - have they finished the sections before this section?
          - set the category_state for that section to in-progress
          - Create unanswered flashcard states for the category flashcards
             We might need to do this on the server or make it so that
             flashcard_states can be created in mass. Creating a 100 of these
             syncronsly isn't going to work.
      */

      // check for other in progress sections
      if( this.inProgressSections.length > 0 ) {
        console.log('All other sections must be completed');
        return;
      }

      // determine which section the user can start
      // this is a bit of naive way of doing this but lets start here until
      // we have an issue
      const allowedNextSection = this.sections[this.completedSections.length];

      if( allowedNextSection.id != section.id ) {
        console.log('Trying to start and out of order section');
        return;
      }


      // Sets the section category_states to in-progress
      await this.startSimulationSection(section);
      // create the unanswered flashcard states for this section
      // Todo: Enforce order
      await this.createUnasweredSimulationStates(section);

      console.log('Started section ', section.name);
      return true;
    },
    sectionFlashcards(section) {
      const flashcards = this.$store.getters['flashcards/flashcardList'];
      const sf = flashcards.filter( f => f.categoryIds.includes(section.id) );
      return sf;
    },
    canAnswerFlashcard(flashcardId) {
      if( !this.currentSection ) {
        return false;
      }
      const flashcards = this.$store.getters['flashcards/flashcardList'];
      const flashcard = flashcards.find( f => f.id == flashcardId );
      const retval = !!flashcard?.categoryIds?.includes(this.currentSection.id);
      return retval;
    },
    async completeSection(section) {
      if( this.inProgressSections.length == 1 && this.inProgressSections[0].id == section.id) {
        await this.completeSimuationSection(section);
      } else {
        console.log('can only completed an in progress section');
      }
    },
    async completeSimuationSection(category) {
      const statusId = this.
        $store.
        getters['categoryStatuses/completedStatus'].
        id;
      let params = {
        number: 0,
        categoryStatusId: statusId,
        categoryId: category.id,
        mobileCreatedAt: Date.now(),
      };
      this.$store.dispatch('categoryStates/sendCategoryState', params);
    },
    async startSimulationSection(category) {
      const statusId = this.
        $store.
        getters['categoryStatuses/inProgressStatus'].
        id;
      let params = {
        number: 0,
        categoryStatusId: statusId,
        categoryId: category.id,
        mobileCreatedAt: Date.now(),
      };
      this.$store.dispatch('categoryStates/sendCategoryState', params);
    },
    async createUnasweredSimulationStates(section) {
      await this.$store.dispatch('flashcards/fetchFlashcards', {
        categoryId: section.id,
      });
      const f = this.$store.getters['flashcards/flashcardList'];
      let flashcards = f.filter( f => f.categoryIds.includes(section.id) );
      // TODO: Do some awesomes magic to sort the section flashcards in to the
      // right order

      const unansweredFlashcardStatusId = this.
        $store.
        getters['flashcardStatuses/unansweredFlashcardStatus'].
        id;
      let flashcardStates = [];
      let timeStamp = Date.now();
      flashcards.forEach( (flashcard) => {
        flashcardStates.push({
          categoryId: section.id,
          flashcardId: flashcard.id,
          flashcardStatusId: unansweredFlashcardStatusId,
          mobileCreatedAt: timeStamp,
          number: 0,
          time_in_seconds: 0,
        });
        timeStamp = timeStamp + 1;
      });

      // TODO: Change this to allow sending multiple flashcard states at once
      flashcardStates.forEach( (flashcardState) => {
        this.$store.dispatch('flashcardStates/send', flashcardState);
      });
    },
    /* END WUX SIMULATION */

    finishedSimulation(category) {
      return this.lastCategoryState(category).categoryStatusId === this.$store.getters['categoryStatuses/completedStatus'].id;
    },
    lastCategoryState(category) {
      return this.$store.getters['categoryStates/categoryStates'][category.id] || {};
    },
    simulationRoute(category) {
      if (this.$access(this.$store, 'category', category.id) && !this.finishedSimulation(category)) {
        let url = '';

        if (process.env.NODE_ENV === 'development') {
          url = `https://${this.$store.getters['app/legacyUrl']}:${process.env.API_PORT}`;
        } else {
          url = `https://${this.$store.getters['app/legacyUrl']}`;
        }

        return `${url}/test_simulations/${category.id}/wux_start`;
      } else {
        return { query: this.currentQuery };
      }
    },
    startedSimulation(category) {
      return !!this.lastCategoryState(category).id;
    },
  },
};
